import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface TenantState {
  activeViewTab: string;
}

const initialState: TenantState = {
  activeViewTab: 'products',
};

export const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenantActiveTab: (state, action: PayloadAction<string>) => {
      state.activeViewTab = action.payload;
    },
  },
});

export const { setTenantActiveTab } = tenantSlice.actions;
export default tenantSlice.reducer;
